import { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import UserContext from "../../context/UserContext";

import api from "../../services/api";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography, Paper } from "@material-ui/core";

import "./styles.css";

import { format } from "date-fns";
import { stepsPerfil, stepsPerfilGestor } from "../Tour/steps";
import { useTour } from "@reactour/tour";
import Tour from "../Tour";

const useStyles = makeStyles({
  titleStyle: {
    margin: "15px",
    marginTop: "15px",
  },
  buttonStyle: {
    margin: "5px",
    marginTop: "30px",
    marginBottom: "16px",
    fontSize: "10px",
    fontWeight: 600,
  },
  iconStyle: {
    fontSize: "16px",
  },
  leftIconStyle: {
    fontSize: "16px",
    marginLeft: "6px",
  },
  fileStyle: {
    fontSize: "14px",
    marginRight: "8px",
    color: "#757575",
  },
  listStyle: {
    fontSize: "26px",
    color: "#388e3c",
    marginLeft: "6px",
  },
});


const inicialNome = (owner) => {
  if (!owner || typeof owner !== "string") return "??";
  let listaNome = owner.split(" ");
  let tamanhoListaNome = listaNome.length;
  let sigla = listaNome[0][0] + listaNome[tamanhoListaNome - 1][0];

  return sigla;
};

function Perfil() {
  const { userData } = useContext(UserContext);
  const history = useHistory();
  const classes = useStyles();

  const [user, setUser] = useState({});
  const [isProjectManager, setIsProjectManager] = useState("");
  const [documentos, setDocumentos] = useState([]);

  const { setSteps } = useTour();

  useEffect(() => {
    console.log(userData)
    if(userData?.user?.isProjectManager) {
      setSteps(stepsPerfilGestor)
    } else {
      setSteps(stepsPerfil);
    }
    
  }, [setSteps, userData]);

  console.log("documentos", documentos);

  useEffect(() => {
    async function perfilInfoHandler() {
      try {
        let token = localStorage.getItem("auth-token");
        const userRes = await api.get("/api/user/perfil", {
          headers: { "x-auth-token": token },
        });
        const documentoRes = await api.get("/documentos", {
          headers: { "x-auth-token": token },
        });
        setUser(userRes.data);
        setDocumentos(documentoRes.data);
      } catch (err) {}
    }

    perfilInfoHandler();
    const getUserInfo = async () => {
      try {
        let token = localStorage.getItem("auth-token");
        const response = await api.get("/api/user/perfil", {
          headers: { "x-auth-token": token },
        });
        const userData = response.data;

        setIsProjectManager(userData?.isProjectManager);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    getUserInfo();
  }, []);

  function redirectHandler() {
    history.push("/nova-ata");
  }

  function redirecionarPara() {
    history.push("/documentos-ata");
  }

  function redirectPainel() {
    history.push("/planejamento-projeto");
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Paper elevation={2}
        style={{ width: "30%", display: "flex", flexDirection: "column" }}
        >
        {/* <div className="perfil-container"> */}
        <div className="suas-atas">
          <p
            className="ultimasAtualizacoesTitle"
            style={{
              fontSize: "24px",
              color: "#00293B",
              textAlign: "center",
              paddingTop: "50px",
            }}
          >
            <strong>Últimas atualizações</strong>
          </p>

          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
                marginTop: "-50px",
              }}
            >
              {documentos.length !== 0 && (
                <ul
                  style={{
                    overflowY: "auto",
                    height: "80vh",
                    marginTop: "60px",
                    paddingLeft: "100px",
                    paddingRight: "100px",
                  }}
                >
                  {documentos.map((ata) => (
                    <li key={ata._id}>
                      <div
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => history.push("/nova-ata/" + ata._id)}
                      >
                        <Paper
                          elevation={3}
                          style={{
                            display: "flex",
                            height: "20vh",
                            width: "20vw",
                            borderRadius: "20px",
                            justifyContent: "start",
                            padding: 12,
                            paddingLeft: 40,
                            overflowY: "auto",
                            marginBottom: "10px",
                            marginTop: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              // width: "100%",
                            }}
                          >
                            <p
                              className="suasatas"
                              style={{
                                color: "#3900DB",
                                height: "80px",
                                fontSize: "1rem",

                                fontWeight: 700,
                                lineHeight: "1.5",
                                letterSpacing: "0.00938em",
                                margin: "0px",
                              }}
                            >
                              {ata.projeto?.nome || ata.projeto}
                            </p>
                            <p
                              className="suasatas"
                              style={{
                                color: "#000",
                                height: "80px",
                                fontSize: "18px",

                                fontWeight: 500,
                                lineHeight: "1.5",
                                letterSpacing: "0.00938em",
                                margin: "0px",
                                justifyContent: "start",
                              }}
                            >
                              {ata.cliente}
                            </p>
                            <p
                              className="suasatas"
                              style={{
                                color: "#858585",
                                display: "flex",
                                height: "80pl",
                                fontSize: "14px",

                                fontWeight: 400,
                                fontStyle: "italic",
                                lineHeight: "1.5",
                                letterSpacing: "0.00938em",
                                margin: "0px",
                              }}
                            >
                              <div
                                style={{
                                  marginRight: "1rem",
                                  width: "20%",
                                  display: "flex",
                                  marginTop: "-2px",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="23"
                                  height="23"
                                  viewBox="0 0 36 36"
                                  fill="none"
                                >
                                  <circle
                                    cx="18"
                                    cy="18"
                                    r="18"
                                    fill="#3E2388"
                                  />
                                </svg>
                                <div
                                  style={{
                                    marginTop: "-39px",
                                    marginLeft: "-19px",
                                    color: "white",
                                    fontSize: "13px",
                                    fontStyle: "normal",
                                  }}
                                >
                                  {inicialNome(ata.owner?.nome)}
                                </div>
                              </div>
                              {ata.date ? format(new Date(ata.date?.$date || ata.date), "dd/MM/yyyy") : "-"}
                            </p>
                          </div>
                        </Paper>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
        {/* </div> */}
      </Paper>
      <Paper
        elevation={2}
        style={{ width: "70%", display: "flex", flexDirection: "row" }}
      >
        <div className="perfil-container">
          <div className="suas-atas">
            <Typography
              className={classes.titleStyle}
              align="center"
              variant="h4"
            >
              <p className="novaAtaTitulo">
                Bem-vindo(a), {user.nome || 'Usuário'}!<br></br>
                <br></br>O que deseja realizar?
              </p>
            </Typography>

            {/* div com todas as bolinhas */}
            <div  className="atalhosPerfil" style={{ display: "flex", justifyContent: "space-between" }}>
              {/* div das bolinhas */}
              <div
                style={{
                  backgroundColor: "#00293B",
                  borderRadius: "120px",
                  width: "150px",
                  height: "150px",
                  display: "flex",
                }}
              >
                <div style={{ marginLeft: "40px", alignSelf: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="80"
                    viewBox="0 0 103 114"
                    fill="none"
                  >
                    <path
                      d="M54.2105 0H10.8421C4.82474 0 0 4.83143 0 10.8571V97.7143C0 103.74 4.82474 108.571 10.8421 108.571H53.1805C50.3074 103.631 48.7895 97.9857 48.7895 92.2857C48.7895 90.4943 48.9521 88.6486 49.2232 86.8571H10.8421V76H53.1805C55.6742 71.6571 59.1437 67.8571 63.3179 65.1429H10.8421V54.2857H75.8947V60.1486C77.6837 59.8771 79.5268 59.7143 81.3158 59.7143C83.1047 59.7143 84.9479 59.8771 86.7368 60.1486V32.5714L54.2105 0ZM48.7895 38V8.14286L78.6053 38H48.7895ZM75.8947 70.5714V86.8571H59.6316V97.7143H75.8947V114H86.7368V97.7143H103V86.8571H86.7368V70.5714H75.8947Z"
                      fill="#B7D400"
                    />
                  </svg>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "#00293B",
                  borderRadius: "120px",
                  width: "150px",
                  height: "150px",
                  display: "flex",
                }}
              >
                {" "}
                <div
                  style={{
                    marginLeft: 37,
                    alignSelf: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="80"
                    viewBox="0 0 111 100"
                    fill="none"
                  >
                    <path
                      d="M68.7143 21.0526C57.0329 21.0526 47.5714 30.4737 47.5714 42.1053V84.2105H10.5714C4.75714 84.2105 0 79.5263 0 73.6842V10.5263C0 4.68421 4.70429 0 10.5714 0H42.2857L52.8571 10.5263H95.1429C100.957 10.5263 105.714 15.2105 105.714 21.0526V32.4737L97.31 24.1579L94.2443 21.0526H68.7143ZM111 52.6316V89.4737C111 95.3158 106.296 100 100.429 100H68.7143C62.9 100 58.1429 95.3158 58.1429 89.4737V42.1053C58.1429 36.3158 62.9 31.5789 68.7143 31.5789H89.8571L111 52.6316ZM100.429 57L85.47 42.1053H84.5714V57.8947H100.429V57Z"
                      fill="#B7D400"
                    />
                  </svg>
                </div>
              </div>
              {isProjectManager ? (
                <div
                  style={{
                    backgroundColor: "#00293B",
                    borderRadius: "120px",
                    width: "150px",
                    height: "150px",
                    display: "flex",
                  }}
                >
                  {isProjectManager ? (
                    <div
                      style={{
                        alignSelf: "center",
                        marginLeft: 37,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="80"
                        height="80"
                        viewBox="0 0 110 110"
                        fill="none"
                      >
                        <path
                          d="M17.3684 78.1579L0 95.1789V46.3158H17.3684M46.3158 67.5053L37.2263 59.7474L28.9474 67.3895V23.1579H46.3158M75.2632 57.8947L57.8947 75.2632V0H75.2632M91.5316 56.7947L81.0526 46.3158H110V75.2632L99.6368 64.9L57.8947 106.295L37.8053 88.8105L15.9211 110H0L37.4579 73.2947L57.8947 90.5474"
                          fill="#B7D400"
                        />
                      </svg>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
            {/* div com todos os botoes */}
            <div
           
              style={{
                paddingLeft: "-20px",
                marginTop: "-50px",
                marginLeft: "15px",
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <Button
                style={{
                  textDecoration: "none",
                  textTransform: "none",
                  fontSize: "16px",
                }}
                variant="contained"
                color="#000"
                className={`novaAta ${classes.buttonStyle}`}
                type="submit"
                onClick={redirectHandler}
              >
                Nova Ata
              </Button>

              <Button
                style={{
                  textDecoration: "none",
                  textTransform: "none",
                  fontSize: "16px",
                  justifyContent: "center",
                  marginLeft: "40px",
                }}
                variant="contained"
                color="#000"
                className={`abrirDocumento ${classes.buttonStyle}`}
                type="submit"
                onClick={redirecionarPara}
              >
                Abrir documento
              </Button>
              {isProjectManager ? (
                <Button
                  style={{
                    textDecoration: "none",
                    textTransform: "none",
                    fontSize: "16px",
                    marginRight: "-4px",
                  }}
                  variant="contained"
                  color="#000"
                  className={`abrirPainelGestao ${classes.buttonStyle}`}
                  type="submit"
                  onClick={redirectPainel}
                >
                  Painel de gestão
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <div style={{ marginLeft: '35rem'}}>
              <Tour></Tour>
            </div>
           
            
          </div>
          
        </div>
        
      </Paper>
     
    </div>
  );
}

export default Perfil;
